export const OrderRoute = {
  path: '/order/details',
  load: () => import('./Order'),
  protected: true,
};

export const OrderDetailsRoute = {
  path: '/order/details/:id',
  load: () => import('./Order'),
  protected: true,
};

export const EditHistoryRoute = {
  path: '/order/editHistory/:id',
  load: () => import('./EditHistory'),
  protected: true,
};
